module.exports = __webpack_public_path__ + "img/3.08419489.webp";